import { DietSettingsConnectorApollo } from '@front-activerse/common-components';
import DietSettingsQuery from '../DietSettings/graphql/DietSettingsQuery';
import TrackerContainer from './TrackerSettingsContainer';
import { DietIdEnum } from '@front-activerse/common-components';

interface ITrackerSettingsPage {
  dietTypes?: {
    id: number;
    value: DietIdEnum;
    optionTitle: string;
    optionDescription: string;
  }[];
  dietLevels?: {
    id: number;
    value: DietIdEnum;
    optionTitle: string;
    optionDescription: string;
  }[];
}
const TrackerSettingsPage = ({ dietTypes, dietLevels }: ITrackerSettingsPage) => {
  return (
    <DietSettingsConnectorApollo query={DietSettingsQuery}>
      {({ ...dietSettingsData }) => {
        return (
          <TrackerContainer {...dietSettingsData} dietTypes={dietTypes} dietLevels={dietLevels} />
        );
      }}
    </DietSettingsConnectorApollo>
  );
};

export default TrackerSettingsPage;
